var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C18.6274 0 24 5.37258 24 12C23.9967 18.626 18.626 23.9967 12 24C5.37395 23.9967 0.00331054 18.626 0 12C0 5.37258 5.37258 0 12 0ZM19.1874 8.38934C19.0133 7.74297 18.5086 7.23792 17.8624 7.06334C15.9176 6.83186 13.9597 6.72764 12.0014 6.75134C10.043 6.72797 8.08514 6.83252 6.14037 7.06434C5.49391 7.23856 4.98909 7.74376 4.81537 8.39034C4.59931 9.5817 4.49452 10.7906 4.50237 12.0013C4.49449 13.2114 4.59928 14.4197 4.81537 15.6103C4.98897 16.2572 5.49376 16.7628 6.14037 16.9373C8.0851 17.1696 10.043 17.2741 12.0014 17.2503C13.9598 17.2741 15.9176 17.1696 17.8624 16.9373C18.5088 16.7624 19.0134 16.257 19.1874 15.6103C19.4035 14.4197 19.5082 13.2114 19.5004 12.0013C19.5082 10.7906 19.4034 9.5817 19.1874 8.39034V8.38934ZM10.5 14.25V9.75L14.4 12L10.5 14.25Z",
    fill: "#00ABE8"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.1cef0c5a5359502179bf899ae1dd10c5.svg";
export { ForwardRef as ReactComponent };